import { destroy, get, getOne, post, put } from "../apis/httpClient";

export const listCollection = () => get('/api/v1/collection/list')
export const pagingCollection = (params) => get('/api/v1/collection/paging',params)
export const detailCollection =(query)=>getOne(`/api/v1/collection/detail/${query}`)
export const updateCollection =(body)=>put(`/api/v1/collection/update`,body)
export const createCollection =(body)=>post(`/api/v1/collection/create`,body)
export const deleteCollection = (body) => destroy(`/api/v1/collection/delete`,body)